import { render, staticRenderFns } from "./batchDeal.vue?vue&type=template&id=e3cadb10&scoped=true"
import script from "./batchDeal.vue?vue&type=script&lang=js"
export * from "./batchDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cadb10",
  null
  
)

export default component.exports